import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { AsyncTeamSelect } from './function';

export const AsyncTeamSelectFormField = FormFieldBlueprint.make({
  name: 'async-team-select',
  params: {
    field: async () =>
      createFormField({
        name: 'AsyncTeamSelect',
        component: AsyncTeamSelect,
      }),
  },
});
